import { useCallback, useEffect, useState } from 'react';
export function usePinKeyboard({ onConfirm, onCancel, onClose, maxLength = 6, initialValue = '', show = true, disabled = false, } = {}) {
    const [pin, setPin] = useState(initialValue);
    const [isVisible, setIsVisible] = useState(false);
    const isComplete = pin.length === maxLength;
    const addDigit = useCallback((digit) => {
        if (pin.length < maxLength && /^\d$/.test(digit)) {
            setPin(prev => prev + digit);
        }
    }, [pin.length, maxLength]);
    const removeDigit = useCallback(() => {
        setPin(prev => prev.slice(0, -1));
    }, []);
    const clearPin = useCallback(() => {
        setPin('');
    }, []);
    const toggleVisibility = useCallback(() => {
        setIsVisible(prev => !prev);
    }, []);
    const handleConfirm = useCallback(() => {
        if (isComplete && onConfirm) {
            onConfirm(pin);
        }
    }, [isComplete, onConfirm, pin]);
    const handleCancel = useCallback(() => {
        if (onCancel) {
            onCancel();
        }
    }, [onCancel]);
    useEffect(() => {
        if (show) {
            clearPin();
        }
    }, [clearPin, show]);
    const handleKeyClick = useCallback((digit) => {
        if (!disabled) {
            addDigit(digit);
        }
    }, [disabled, addDigit]);
    const handleDeleteClick = useCallback(() => {
        if (!disabled) {
            removeDigit();
        }
    }, [disabled, removeDigit]);
    const handleConfirmClick = useCallback(() => {
        if (!disabled && isComplete) {
            handleConfirm();
        }
    }, [disabled, isComplete, handleConfirm]);
    const handleCloseClick = useCallback(() => {
        if (!disabled) {
            if (onClose) {
                onClose();
            }
            else {
                handleCancel();
            }
        }
    }, [disabled, onClose, handleCancel]);
    const handleVisibilityToggle = useCallback(() => {
        if (!disabled) {
            toggleVisibility();
        }
    }, [disabled, toggleVisibility]);
    const renderPinDisplay = useCallback(() => {
        const displayValue = isVisible ? pin : '*'.repeat(pin.length);
        const placeholder = '*'.repeat(maxLength);
        return pin.length > 0 ? displayValue : placeholder;
    }, [isVisible, pin, maxLength]);
    const keyboardNumbers = [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['', '0', 'delete'],
    ];
    return {
        pin,
        isVisible,
        isComplete,
        addDigit,
        removeDigit,
        clearPin,
        toggleVisibility,
        handleConfirm,
        handleCancel,
        handleKeyClick,
        handleDeleteClick,
        handleConfirmClick,
        handleCloseClick,
        handleVisibilityToggle,
        renderPinDisplay,
        keyboardNumbers,
    };
}
